module.exports = __webpack_public_path__ + "img/post-2.8193c78a.jpg";